export const calculatePage = (total, limit) => {
  let totalPage = Math.floor(total / limit);
  if (total % limit !== 0) {
    totalPage++;
  }

  return totalPage;
};
